// src/components/Dashboard.jsx
import React, { useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell } from 'recharts';
import { getAuth, signOut } from 'firebase/auth';
import TrustMeter from './TrustMeter';
import ProduccionForm from './ProduccionForm';
import RegistroManual from './RegistroManual';
import ConfiguracionAuditoria from './ConfiguracionAuditoria';
import Inventario from './Inventario';
import ExecutiveReport from './ExecutiveReport';
import MassiveUpload from './MassiveUpload';
import ModalUpgrade from './ModalUpgrade';
import ModalFechaVencimiento from './ModalFechaVencimiento';
import CheckoutMercadoPago from './CheckoutMercadoPago';
import SupportBot from './SupportBot';
import SelectorReporte from './SelectorReporte';
import TooltipIcon from './TooltipIcon';
import DashboardInsights from './DashboardInsights';
import { useTranslation } from '../hooks/useTranslation';
import MobileTabs from './MobileTabs';

const Dashboard = ({
  usuarioActual,
  movimientos,
  inventario,
  cuentasPorPagar,
  isLoading,
  error,
  validationMessage,
  setValidationMessage,
  setError,
  generandoReporte,
  setGenerandoReporte,
  ventasTotales,
  gastosTotales,
  utilidadEstimada,
  margen,
  saldoCaja,
  diasCubiertos,
  margenNeto,
  diasInactividad,
  productosEstrella,
  productosHueso,
  gastosFijosMensuales,
  tendenciaVentas,
  valoresAtipicos,
  inconsistenciaSaldo,
  mostrarLogsEliminaciones,
  setMostrarLogsEliminaciones,
  logsEliminaciones,
  variaciones,
  moneda,
  setGastosFijosMensuales,
  setMostrarConfigModal,
  setModalUpgradeOpen,
  setFuncionBloqueada,
  exportarACSV,
  puedeAccederAFuncion,
  subiendoArchivo,
  handleFileUpload,
  setModalReporteAbierto,
  handleGenerarReporte,
  modalReporteAbierto,
  setShowProduccion,
  showProduccion,
  setShowRegistroManual,
  showRegistroManual,
  setInventario,
  setMovimientos,
  guardarProductoEnCatalogo,
  calcularDiasParaVencer,
  formatearValor,
  handleDelete,
  mostrarCheckout,
  setMostrarCheckout,
  planSeleccionadoPago,
  setPlanSeleccionadoPago,
  modalUpgradeOpen,
  funcionBloqueada,
  mostrarModalVencimiento,
  setMostrarModalVencimiento,
  handleGuardarConVencimiento,
  handleSaltarVencimiento,
  productoPendiente,
  resumenFinanciero,
  diagnosticoBienvenida,
  datosGrafico,
  setShowAuditoria,
  showAuditoria,
  dictamenGeneral
}) => {
  const { t, idioma, cambiarIdioma } = useTranslation();
  const [showAuditoriaLocal, setShowAuditoriaLocal] = useState(false);
  const [isConfigOpen, setIsConfigOpen] = useState(false);
  
  // Estado para controlar si el header está expandido o colapsado en móvil
  const [mobileHeaderExpanded, setMobileHeaderExpanded] = useState(false);
  
  const getDiasRestantes = () => {
    if (!usuarioActual?.fechaVencimiento) return 0;
    const fechaVenc = usuarioActual.fechaVencimiento?.toDate 
      ? usuarioActual.fechaVencimiento.toDate() 
      : new Date(usuarioActual.fechaVencimiento);
    const dias = Math.ceil((fechaVenc - new Date()) / (1000 * 60 * 60 * 24));
    return dias > 0 ? dias : 0;
  };

  const diasRestantes = getDiasRestantes();
  const plan = usuarioActual?.plan || 'starter';

  let tieneAcceso = false;
  if (plan === 'starter') {
    tieneAcceso = diasRestantes > 0;
  } else if (plan === 'pro' || plan === 'business' || plan === 'elite') {
    tieneAcceso = true;
  }

  console.log('🔍 Dashboard renderizado - Plan:', plan, 'Días:', diasRestantes, 'Acceso:', tieneAcceso);

  // Componentes reutilizables
  console.log('🔍 Dashboard - gastosFijosMensuales antes de enviar:', gastosFijosMensuales);

  // ✅ CARGAR GASTOS FIJOS DIRECTAMENTE DESDE FIRESTORE
useEffect(() => {
  console.log('🔴🔴🔴 EFECTO EJECUTÁNDOSE EN DASHBOARD 🔴🔴🔴');
  console.log('🔴 usuarioActual?.uid:', usuarioActual?.uid);
  
  const cargarGastosFijos = async () => {
    console.log('🔴 Función cargarGastosFijos iniciada');
    
    if (!usuarioActual?.uid) {
      console.log('🔴 No hay usuario, saliendo');
      return;
    }
    
    try {
      console.log('🔴 Importando firebase/firestore...');
      const { getFirestore, doc, getDoc } = await import('firebase/firestore');
      console.log('🔴 Firebase importado correctamente');
      
      const db = getFirestore();
      console.log('🔴 Firestore inicializado');
      
      // 👇 CORRECCIÓN AQUÍ: Se eliminó la tilde para que coincida con Firestore y las Reglas
      const configRef = doc(db, 'configuracion_auditoria', usuarioActual.uid);
      console.log('🔴 Referencia al documento creada:', configRef.path);
      
      const configSnap = await getDoc(configRef);
      console.log('🔴 Documento existe?', configSnap.exists());
      
      if (configSnap.exists()) {
        const data = configSnap.data();
        console.log('🔴 Datos del documento:', data);
        console.log('🔴 gastosFijosMensuales en Firestore:', data.gastosFijosMensuales);
        console.log('🔴 gastosFijosMensuales actual en estado:', gastosFijosMensuales);
        
        if (data.gastosFijosMensuales && data.gastosFijosMensuales !== gastosFijosMensuales) {
          setGastosFijosMensuales(data.gastosFijosMensuales);
          console.log('✅ Gastos fijos cargados en Dashboard:', data.gastosFijosMensuales);
        } else {
          console.log('⚠️ No se actualizó porque el valor es igual o no existe');
        }
      } else {
        console.log('⚠️ No existe documento configuracion_auditoria para este usuario');
      }
    } catch (error) {
      console.error('❌ Error cargando gastos fijos:', error);
    }
  };
  
  cargarGastosFijos();
}, [usuarioActual?.uid]);

const dashboardInsightsComponent = (
    <DashboardInsights 
      saldoCaja={saldoCaja}
      ventasTotales={ventasTotales}
      gastosTotales={gastosTotales}
      margenNeto={margenNeto}
      diasInactividad={diasInactividad}
      productosEstrella={productosEstrella}
      productosHueso={productosHueso}
      gastosFijosMensuales={gastosFijosMensuales}
      tendenciaVentas={tendenciaVentas}
      usuarioActual={usuarioActual}
      idioma={idioma}
    />
  );

  const dictamenAuditoriaComponent = (
    <ExecutiveReport 
      ventasTotales={ventasTotales}
      gastosTotales={gastosTotales}
      utilidadEstimada={utilidadEstimada}
      onUpgradeClick={() => {
        setFuncionBloqueada('Executive Report');
        setModalUpgradeOpen(true);
      }}
    />
  );

  // ✅ KPIs (Ventas, Utilidad, Margen, Saldo en Caja) - CORREGIDO: 4 columnas en PC, 2 en móvil
  const kpiCardsComponent = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-3 mb-8">
      {/* Card 1: Ventas */}
      <div className="bg-[#1e293b] border border-blue-900/20 rounded-xl p-2 md:p-3 shadow-lg hover:border-cyan-500/30 transition-all duration-300">
        <div className="flex justify-between items-start gap-2">
          <div className="flex-1 min-w-0">
            <div className="flex items-center flex-wrap">
              <p className="text-gray-400 text-xs md:text-sm font-medium truncate">{t('sales')}</p>
              <TooltipIcon text={t('tooltipSales')} />
            </div>
            <p className="text-lg md:text-2xl font-bold mt-0.5 md:mt-1 text-emerald-400 truncate">{formatearValor(ventasTotales)}</p>
            {puedeAccederAFuncion('puedeVerComparacionMensual') && variaciones && (
              <p className={`text-[10px] md:text-xs mt-0.5 md:mt-1 truncate ${variaciones.ventas.variacion >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                {variaciones.ventas.variacion >= 0 ? '↑' : '↓'} {Math.abs(variaciones.ventas.variacion).toFixed(1)}% {t('salesVariation')}
              </p>
            )}
            {!puedeAccederAFuncion('puedeVerComparacionMensual') && (
              <p className="text-[10px] md:text-xs mt-0.5 md:mt-1 text-gray-500 cursor-pointer hover:text-cyan-400 truncate" onClick={() => { setFuncionBloqueada('Comparación mensual'); setModalUpgradeOpen(true); }}>
                🔒
              </p>
            )}
          </div>
          <div className="bg-cyan-500/10 text-cyan-400 rounded-full w-6 h-6 md:w-8 md:h-8 flex items-center justify-center font-bold text-xs md:text-base flex-shrink-0">💰</div>
        </div>
        <div className="mt-2 md:mt-3 pt-2 md:pt-3 border-t border-blue-900/20 flex justify-between items-center">
          <span className="text-[10px] md:text-xs text-gray-500 truncate">{t('currentPeriod')}</span>
          <span className="text-[10px] md:text-xs font-medium text-emerald-400">+12%</span>
        </div>
      </div>
      
      {/* Card 2: Utilidad */}
      <div className="bg-[#1e293b] border border-blue-900/20 rounded-xl p-2 md:p-3 shadow-lg hover:border-cyan-500/30 transition-all duration-300">
        <div className="flex justify-between items-start gap-2">
          <div className="flex-1 min-w-0">
            <div className="flex items-center flex-wrap">
              <p className="text-gray-400 text-xs md:text-sm font-medium truncate">{t('profit')}</p>
              <TooltipIcon text={t('tooltipProfit')} />
            </div>
            <p className={`text-lg md:text-2xl font-bold mt-0.5 md:mt-1 truncate ${utilidadEstimada >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>{formatearValor(utilidadEstimada)}</p>
            {puedeAccederAFuncion('puedeVerComparacionMensual') && variaciones && (
              <p className={`text-[10px] md:text-xs mt-0.5 md:mt-1 truncate ${variaciones.utilidad.variacion >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                {variaciones.utilidad.variacion >= 0 ? '↑' : '↓'} {Math.abs(variaciones.utilidad.variacion).toFixed(1)}% {t('salesVariation')}
              </p>
            )}
          </div>
          <div className="bg-cyan-500/10 text-cyan-400 rounded-full w-6 h-6 md:w-8 md:h-8 flex items-center justify-center font-bold text-xs md:text-base flex-shrink-0">📈</div>
        </div>
        <div className="mt-2 md:mt-3 pt-2 md:pt-3 border-t border-blue-900/20 flex justify-between items-center">
          <span className="text-[10px] md:text-xs text-gray-500 truncate">{t('netPeriod')}</span>
          <span className={`text-[10px] md:text-xs font-medium truncate ${utilidadEstimada >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>{utilidadEstimada >= 0 ? '+' : '-'}{Math.abs(utilidadEstimada / ventasTotales * 100).toFixed(1)}%</span>
        </div>
      </div>
      
      {/* Card 3: Margen */}
      <div className="bg-[#1e293b] border border-blue-900/20 rounded-xl p-2 md:p-3 shadow-lg hover:border-cyan-500/30 transition-all duration-300">
        <div className="flex justify-between items-start gap-2">
          <div className="flex-1 min-w-0">
            <div className="flex items-center flex-wrap">
              <p className="text-gray-400 text-xs md:text-sm font-medium truncate">{t('margin')}</p>
              <TooltipIcon text={t('tooltipMargin')} />
            </div>
            <p className="text-lg md:text-2xl font-bold mt-0.5 md:mt-1 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 truncate">{margen}%</p>
          </div>
          <div className="bg-cyan-500/10 text-cyan-400 rounded-full w-6 h-6 md:w-8 md:h-8 flex items-center justify-center font-bold text-xs md:text-base flex-shrink-0">📊</div>
        </div>
        <div className="mt-2 md:mt-3 pt-2 md:pt-3 border-t border-blue-900/20 flex justify-between items-center">
          <span className="text-[10px] md:text-xs text-gray-500 truncate">{t('onSales')}</span>
          <span className="text-[10px] md:text-xs font-medium text-cyan-400">+2.1pp</span>
        </div>
      </div>

      {/* Card 4: Saldo en Caja */}
      <div className="bg-[#1e293b] border border-blue-900/20 rounded-xl p-2 md:p-3 shadow-lg hover:border-cyan-500/30 transition-all duration-300">
        <div className="flex justify-between items-start gap-2">
          <div className="flex-1 min-w-0">
            <div className="flex items-center flex-wrap">
              <p className="text-gray-400 text-xs md:text-sm font-medium truncate">{t('balance')}</p>
              <TooltipIcon text={t('tooltipBalance')} />
            </div>
            <p className={`text-lg md:text-2xl font-bold mt-0.5 md:mt-1 truncate ${saldoCaja >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>{formatearValor(saldoCaja)}</p>
          </div>
          <div className="bg-cyan-500/10 text-cyan-400 rounded-full w-6 h-6 md:w-8 md:h-8 flex items-center justify-center font-bold text-xs md:text-base flex-shrink-0">💵</div>
        </div>
        <div className="mt-2 md:mt-3 pt-2 md:pt-3 border-t border-blue-900/20 flex justify-between items-center">
          <span className="text-[10px] md:text-xs text-gray-500 truncate">{t('historicalBalance')}</span>
          <span className={`text-[10px] md:text-xs font-medium truncate ${saldoCaja >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
            {saldoCaja >= 0 ? t('positive') : t('negative')}
          </span>
        </div>
      </div>
    </div>
  );

  // ✅ VERSIÓN MÓVIL DE KPIs (2x2 + compacto) - INTACTA, SIN MODIFICACIONES
  const kpiCardsMobileComponent = (
    <div className="!grid !grid-cols-2 !gap-1.5 !w-full mb-4">
      {/* Card 1: Ventas - Móvil */}
      <div className="bg-[#1e293b] border border-blue-900/20 rounded-xl !p-1.5 shadow-lg">
        <div className="flex justify-between items-start !gap-0.5">
          <div className="flex-1 min-w-0">
            <div className="flex items-center flex-wrap">
              <p className="text-gray-400 !text-[9px] font-medium truncate">{t('sales')}</p>
              <TooltipIcon text={t('tooltipSales')} />
            </div>
            <p className="!text-[10px] font-bold !mt-0 text-emerald-400 truncate">{formatearValor(ventasTotales)}</p>
            {puedeAccederAFuncion('puedeVerComparacionMensual') && variaciones && (
              <p className={`!text-[6px] !mt-0 truncate ${variaciones.ventas.variacion >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                {variaciones.ventas.variacion >= 0 ? '↑' : '↓'} {Math.abs(variaciones.ventas.variacion).toFixed(1)}%
              </p>
            )}
            {!puedeAccederAFuncion('puedeVerComparacionMensual') && (
              <p className="!text-[6px] !mt-0 text-gray-500">🔒</p>
            )}
          </div>
          <div className="bg-cyan-500/10 text-cyan-400 rounded-full !w-3.5 !h-3.5 flex items-center justify-center font-bold !text-[7px] flex-shrink-0">💰</div>
        </div>
        <div className="!mt-0.5 !pt-0 border-t border-blue-900/20 flex justify-between items-center">
          <span className="!text-[5px] text-gray-500 truncate">{t('currentPeriod')}</span>
          <span className="!text-[5px] font-medium text-emerald-400">+12%</span>
        </div>
      </div>
      
      {/* Card 2: Utilidad - Móvil */}
      <div className="bg-[#1e293b] border border-blue-900/20 rounded-xl !p-1.5 shadow-lg">
        <div className="flex justify-between items-start !gap-0.5">
          <div className="flex-1 min-w-0">
            <div className="flex items-center flex-wrap">
              <p className="text-gray-400 !text-[9px] font-medium truncate">{t('profit')}</p>
              <TooltipIcon text={t('tooltipProfit')} />
            </div>
            <p className={`!text-[10px] font-bold !mt-0 truncate ${utilidadEstimada >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>{formatearValor(utilidadEstimada)}</p>
            {puedeAccederAFuncion('puedeVerComparacionMensual') && variaciones && (
              <p className={`!text-[6px] !mt-0 truncate ${variaciones.utilidad.variacion >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                {variaciones.utilidad.variacion >= 0 ? '↑' : '↓'} {Math.abs(variaciones.utilidad.variacion).toFixed(1)}%
              </p>
            )}
          </div>
          <div className="bg-cyan-500/10 text-cyan-400 rounded-full !w-3.5 !h-3.5 flex items-center justify-center font-bold !text-[7px] flex-shrink-0">📈</div>
        </div>
        <div className="!mt-0.5 !pt-0 border-t border-blue-900/20 flex justify-between items-center">
          <span className="!text-[5px] text-gray-500 truncate">{t('netPeriod')}</span>
          <span className={`!text-[5px] font-medium truncate ${utilidadEstimada >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>{utilidadEstimada >= 0 ? '+' : '-'}{Math.abs(utilidadEstimada / ventasTotales * 100).toFixed(1)}%</span>
        </div>
      </div>
      
      {/* Card 3: Margen - Móvil */}
      <div className="bg-[#1e293b] border border-blue-900/20 rounded-xl !p-1.5 shadow-lg">
        <div className="flex justify-between items-start !gap-0.5">
          <div className="flex-1 min-w-0">
            <div className="flex items-center flex-wrap">
              <p className="text-gray-400 !text-[9px] font-medium truncate">{t('margin')}</p>
              <TooltipIcon text={t('tooltipMargin')} />
            </div>
            <p className="!text-[10px] font-bold !mt-0 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 truncate">{margen}%</p>
          </div>
          <div className="bg-cyan-500/10 text-cyan-400 rounded-full !w-3.5 !h-3.5 flex items-center justify-center font-bold !text-[7px] flex-shrink-0">📊</div>
        </div>
        <div className="!mt-0.5 !pt-0 border-t border-blue-900/20 flex justify-between items-center">
          <span className="!text-[5px] text-gray-500 truncate">{t('onSales')}</span>
          <span className="!text-[5px] font-medium text-cyan-400">+2.1pp</span>
        </div>
      </div>

      {/* Card 4: Saldo en Caja - Móvil */}
      <div className="bg-[#1e293b] border border-blue-900/20 rounded-xl !p-1.5 shadow-lg">
        <div className="flex justify-between items-start !gap-0.5">
          <div className="flex-1 min-w-0">
            <div className="flex items-center flex-wrap">
              <p className="text-gray-400 !text-[9px] font-medium truncate">{t('balance')}</p>
              <TooltipIcon text={t('tooltipBalance')} />
            </div>
            <p className={`!text-[10px] font-bold !mt-0 truncate ${saldoCaja >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>{formatearValor(saldoCaja)}</p>
          </div>
          <div className="bg-cyan-500/10 text-cyan-400 rounded-full !w-3.5 !h-3.5 flex items-center justify-center font-bold !text-[7px] flex-shrink-0">💵</div>
        </div>
        <div className="!mt-0.5 !pt-0 border-t border-blue-900/20 flex justify-between items-center">
          <span className="!text-[5px] text-gray-500 truncate">{t('historicalBalance')}</span>
          <span className={`!text-[5px] font-medium truncate ${saldoCaja >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
            {saldoCaja >= 0 ? t('positive') : t('negative')}
          </span>
        </div>
      </div>
    </div>
  );

  const inventarioComponent = (
    <div id="inventario-section" className="mb-8">
      <Inventario usuarioActual={usuarioActual} />
    </div>
  );

  // ============================================================
  // VERSIÓN CON ACORDEÓN PARA PC
  // ============================================================
  const produccionComponent = (() => {
    const puedeAccederProduccion = plan !== 'starter' || diasRestantes > 0;
    
    if (!puedeAccederProduccion) {
      return (
        <div className="mb-4 p-6 bg-slate-800/30 rounded-xl border border-yellow-500/30 text-center">
          <div className="flex flex-col items-center gap-3">
            <span className="text-4xl">🔒</span>
            <h4 className="text-yellow-400 font-bold text-lg">
              {idioma === 'en' ? 'Production Module' : 'Módulo de Producción'}
            </h4>
            <p className="text-gray-400 text-sm max-w-md">
              {idioma === 'en' 
                ? 'Your trial period has ended. Subscribe to a plan to continue using the production module.'
                : 'Tu período de prueba ha terminado. Suscríbete a un plan para seguir usando el módulo de producción.'}
            </p>
            <button 
              onClick={() => {
                setFuncionBloqueada('Módulo de Producción');
                setModalUpgradeOpen(true);
              }}
              className="mt-2 px-6 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-bold rounded-lg transition-all"
            >
              {idioma === 'en' ? 'Subscribe Now' : 'Suscribirme ahora'}
            </button>
          </div>
        </div>
      );
    }
    
    return (
      <div id="produccion-section" className="mb-4">
        <button 
          onClick={() => setShowProduccion(!showProduccion)}
          className="w-full bg-[#1e293b] text-white p-4 rounded-xl flex justify-between items-center border border-blue-900/30 hover:bg-[#2a3a4a] transition-all"
        >
          <span className="font-bold">🏭 {t('productionAudit')}</span>
          <span>{showProduccion ? '▲' : '▼'}</span>
        </button>
        {showProduccion && (
          <div className="mt-2 p-4 bg-[#0f172a] rounded-xl border border-slate-800">
            <ProduccionForm 
              usuarioActual={usuarioActual} 
              idioma={idioma} 
              setInventario={setInventario}
              setMovimientos={setMovimientos}
              onSuccess={() => {
                setValidationMessage('✅ Producción auditada y cargada al inventario');
                setTimeout(() => setValidationMessage(null), 3000);
              }}
              onError={(error) => {
                setError(error.message);
                setTimeout(() => setError(null), 5000);
              }}
            />
          </div>
        )}
      </div>
    );
  })();

  const registroManualComponent = (() => {
    const puedeAccederRegistro = plan !== 'starter' || diasRestantes > 0;
    
    if (!puedeAccederRegistro) {
      return (
        <div className="mb-4 p-6 bg-slate-800/30 rounded-xl border border-yellow-500/30 text-center">
          <div className="flex flex-col items-center gap-3">
            <span className="text-4xl">🔒</span>
            <h4 className="text-yellow-400 font-bold text-lg">
              {idioma === 'en' ? 'Manual Transaction Entry' : 'Registro Manual de Movimientos'}
            </h4>
            <p className="text-gray-400 text-sm max-w-md">
              {idioma === 'en' 
                ? 'Your trial period has ended. Subscribe to a plan to continue recording transactions.'
                : 'Tu período de prueba ha terminado. Suscríbete a un plan para seguir registrando movimientos.'}
            </p>
            <button 
              onClick={() => {
                setFuncionBloqueada('Registro Manual');
                setModalUpgradeOpen(true);
              }}
              className="mt-2 px-6 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-bold rounded-lg transition-all"
            >
              {idioma === 'en' ? 'Subscribe Now' : 'Suscribirme ahora'}
            </button>
          </div>
        </div>
      );
    }
    
    return (
      <div id="registro-manual-section" className="mb-4">
        <button 
          onClick={() => setShowRegistroManual(!showRegistroManual)}
          className="w-full bg-[#1e293b] text-white p-4 rounded-xl flex justify-between items-center border border-blue-900/30 hover:bg-[#2a3a4a] transition-all"
        >
          <span className="font-bold">✍️ {t('manualTransactionEntry')}</span>
          <span>{showRegistroManual ? '▲' : '▼'}</span>
        </button>
        {showRegistroManual && (
          <div className="mt-2 p-4 bg-[#0f172a] rounded-xl border border-slate-800">
            <RegistroManual
              usuarioActual={usuarioActual}
              idioma={idioma}
              saldoActual={saldoCaja}
              guardarProductoEnCatalogo={guardarProductoEnCatalogo}
              onSuccess={() => {
                setValidationMessage(idioma === 'es' ? '✅ Movimiento registrado' : '✅ Transaction recorded');
                setTimeout(() => setValidationMessage(null), 3000);
              }}
              onError={(error) => {
                setError(error.message);
                setTimeout(() => setError(null), 5000);
              }}
            />
          </div>
        )}
      </div>
    );
  })();

  // ============================================================
  // VERSIÓN EXPANDIDA (SIN ACORDEÓN) PARA MÓVIL
  // ============================================================

  const registroManualExpandido = (() => {
    const puedeAccederRegistro = plan !== 'starter' || diasRestantes > 0;
    
    if (!puedeAccederRegistro) {
      return (
        <div className="p-6 bg-slate-800/30 rounded-xl border border-yellow-500/30 text-center">
          <div className="flex flex-col items-center gap-3">
            <span className="text-4xl">🔒</span>
            <h4 className="text-yellow-400 font-bold text-lg">
              {idioma === 'en' ? 'Manual Transaction Entry' : 'Registro Manual de Movimientos'}
            </h4>
            <p className="text-gray-400 text-sm max-w-md">
              {idioma === 'en' 
                ? 'Your trial period has ended. Subscribe to a plan to continue recording transactions.'
                : 'Tu período de prueba ha terminado. Suscríbete a un plan para seguir registrando movimientos.'}
            </p>
            <button 
              onClick={() => {
                setFuncionBloqueada('Registro Manual');
                setModalUpgradeOpen(true);
              }}
              className="mt-2 px-6 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-bold rounded-lg transition-all"
            >
              {idioma === 'en' ? 'Subscribe Now' : 'Suscribirme ahora'}
            </button>
          </div>
        </div>
      );
    }
    
    return (
      <div className="bg-[#0f172a] rounded-xl border border-slate-800 p-4">
        <RegistroManual
          usuarioActual={usuarioActual}
          idioma={idioma}
          saldoActual={saldoCaja}
          guardarProductoEnCatalogo={guardarProductoEnCatalogo}
          onSuccess={() => {
            setValidationMessage(idioma === 'es' ? '✅ Movimiento registrado' : '✅ Transaction recorded');
            setTimeout(() => setValidationMessage(null), 3000);
          }}
          onError={(error) => {
            setError(error.message);
            setTimeout(() => setError(null), 5000);
          }}
        />
      </div>
    );
  })();

  const produccionExpandido = (() => {
    const puedeAccederProduccion = plan !== 'starter' || diasRestantes > 0;
    
    if (!puedeAccederProduccion) {
      return (
        <div className="p-6 bg-slate-800/30 rounded-xl border border-yellow-500/30 text-center">
          <div className="flex flex-col items-center gap-3">
            <span className="text-4xl">🔒</span>
            <h4 className="text-yellow-400 font-bold text-lg">
              {idioma === 'en' ? 'Production Module' : 'Módulo de Producción'}
            </h4>
            <p className="text-gray-400 text-sm max-w-md">
              {idioma === 'en' 
                ? 'Your trial period has ended. Subscribe to a plan to continue using the production module.'
                : 'Tu período de prueba ha terminado. Suscríbete a un plan para seguir usando el módulo de producción.'}
            </p>
            <button 
              onClick={() => {
                setFuncionBloqueada('Módulo de Producción');
                setModalUpgradeOpen(true);
              }}
              className="mt-2 px-6 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-bold rounded-lg transition-all"
            >
              {idioma === 'en' ? 'Subscribe Now' : 'Suscribirme ahora'}
            </button>
          </div>
        </div>
      );
    }
    
    return (
      <div className="bg-[#0f172a] rounded-xl border border-slate-800 p-4">
        <ProduccionForm 
          usuarioActual={usuarioActual} 
          idioma={idioma} 
          setInventario={setInventario}
          setMovimientos={setMovimientos}
          onSuccess={() => {
            setValidationMessage('✅ Producción auditada y cargada al inventario');
            setTimeout(() => setValidationMessage(null), 3000);
          }}
          onError={(error) => {
            setError(error.message);
            setTimeout(() => setError(null), 5000);
          }}
        />
      </div>
    );
  })();

  const configuracionAuditoriaComponent = (
    <div className="bg-[#1e293b] border border-blue-900/30 rounded-2xl p-6 h-full">
      <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
        <span>🛠️</span> {t('configuracionAuditoria')}
      </h3>
      <ConfiguracionAuditoria 
        usuarioActual={usuarioActual} 
        idioma={idioma}
        onClose={() => setMostrarConfigModal(false)}
        onConfigUpdate={(nuevaConfig) => {
          console.log('🔍 Configuración recibida:', nuevaConfig);
          setGastosFijosMensuales(nuevaConfig.gastosFijosMensuales);
        }}
      />
    </div>
  );

  const executiveReportComponent = (
    <ExecutiveReport 
      ventasTotales={ventasTotales}
      gastosTotales={gastosTotales}
      utilidadEstimada={utilidadEstimada}
      onUpgradeClick={() => {
        setFuncionBloqueada('Executive Report');
        setModalUpgradeOpen(true);
      }}
    />
  );

  const registrosListComponent = (
    <section id="registros-section">
      <div className="flex justify-between items-center mb-6 flex-wrap gap-2">
        <h2 className="text-2xl font-bold text-white">{t('financialRecords')}</h2>
        <span className="text-cyan-400 text-sm font-medium">{movimientos.length} {t('totalTransactions')}</span>
      </div>

      {isLoading ? (
        <div className="space-y-4">{[...Array(3)].map((_, i) => (<div key={i} className="bg-[#1e293b]/50 border border-blue-900/20 rounded-xl p-5 animate-pulse"><div className="flex items-center justify-between"><div className="flex items-center"><div className="w-10 h-10 bg-slate-800 rounded-xl mr-4"></div><div><div className="h-4 w-32 bg-slate-800 rounded"></div><div className="h-3 w-24 bg-slate-800 rounded mt-2"></div></div></div><div className="h-6 w-20 bg-slate-800 rounded"></div></div></div>))}</div>
      ) : movimientos.length === 0 ? (
        <div className="bg-[#1e293b] border border-dashed border-blue-900/30 rounded-xl p-8 text-center"><p className="text-gray-500">{t('noRecords')}</p><p className="text-gray-400 text-sm mt-2">{t('writeOperation')}</p></div>
      ) : (
        <div className="space-y-3">
          {movimientos.map((movimiento, index) => (
            <div key={movimiento.id} className="bg-[#1e293b] border border-blue-900/20 rounded-xl p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between hover:border-cyan-500/40 transition-all duration-300 group animate-fade-in-up" style={{ animationDelay: `${index * 0.05}s` }}>
              <div className="flex items-center flex-1 w-full sm:w-auto">
                <div className="text-3xl mr-4 w-10 flex-shrink-0">{movimiento.emoji || '📄'}</div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-white break-words text-sm sm:text-base">{movimiento.concepto || movimiento.texto || 'Sin concepto'}</p>
                  <p className="text-sm text-gray-400">{movimiento.categoria || 'Sin categoría'}</p>
                  {movimiento.recomendacion && <p className="text-xs text-gray-500 mt-1 truncate max-w-[200px] sm:max-w-md">{movimiento.recomendacion}</p>}
                  {(movimiento.proveedor || movimiento.numeroFactura) && (
                    <p className="text-xs text-cyan-400 mt-1 truncate max-w-[200px] sm:max-w-md">
                      {movimiento.proveedor && `Proveedor: ${movimiento.proveedor}`}
                      {movimiento.numeroFactura && ` | Factura: ${movimiento.numeroFactura}`}
                    </p>
                  )}
                  {movimiento.fechaVencimiento && (
                    <p className="text-xs text-orange-400 mt-1">
                      📅 Vence: {new Date(movimiento.fechaVencimiento).toLocaleDateString('es-CO')}
                      {calcularDiasParaVencer(movimiento.fechaVencimiento) <= 3 && ` (¡URGENTE!)`}
                    </p>
                  )}
                </div>
              </div>
              <div className="flex items-center justify-between w-full sm:w-auto mt-3 sm:mt-0">
                <div className="text-right">
                  <p className={`text-lg font-bold ${movimiento.tipo === 'ingreso' ? 'text-emerald-400' : 'text-red-400'}`}>
                    {movimiento.tipo === 'ingreso' ? '+' : '-'} {formatearValor(movimiento.valor || 0)}
                  </p>
                  <p className="text-xs text-gray-500">
                    {movimiento.fecha ? new Date(movimiento.fecha).toLocaleDateString('es-CO') : 'Hoy'}
                  </p>
                </div>
    <button 
  onClick={() => {
    if (!movimiento.id) {
      alert('Error: ID no encontrado');
      return;
    }
    handleDelete(
      movimiento.id,
      movimientos || [],
      setMovimientos,
      setInventario,
      (data) => {}, // ← FUNCIÓN VACÍA (no necesitas actualizar usuario desde aquí)
      setValidationMessage || (() => {}),
      setError || (() => {}),
      (state) => {} // ← FUNCIÓN VACÍA
    );
  }}
  className="ml-3 opacity-0 group-hover:opacity-100 transition-opacity text-gray-500 hover:text-red-400 p-2 rounded-lg"
>
  🗑️
</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );

  return (
    <div className="min-h-screen bg-[#0f172a] text-gray-100 font-sans">
      {/* HEADER - COMPLETAMENTE COLAPSABLE EN MÓVIL */}
      <header className="py-3 px-4 border-b border-blue-900/30 sticky top-0 bg-[#0f172a]/95 backdrop-blur-sm z-10">
        <div className="max-w-7xl mx-auto">
          {/* Fila 1: Logo + botón de colapso (solo móvil) */}
          <div className="flex items-center justify-between">
            <h1 className="text-2xl md:text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-500">
              {t('title')}
            </h1>
            
            {/* Botón para expandir/colapsar el header en móvil */}
            <button
              onClick={() => setMobileHeaderExpanded(!mobileHeaderExpanded)}
              className="md:hidden p-2 bg-slate-800/50 rounded-lg text-gray-400 text-sm"
            >
              {mobileHeaderExpanded ? '▲ Ocultar menú' : '▼ Mostrar menú'}
            </button>
          </div>
          
          {/* Todo lo demás - COLAPSABLE en móvil */}
          <div className={`transition-all duration-300 overflow-hidden ${mobileHeaderExpanded ? 'max-h-[500px] opacity-100 mt-3' : 'max-h-0 opacity-0 md:max-h-full md:opacity-100 md:mt-0'}`}>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
              <div className="flex flex-wrap items-center gap-2">
                <select
                  value={idioma}
                  onChange={(e) => cambiarIdioma(e.target.value)}
                  className="bg-slate-800 border border-slate-700 rounded-lg px-2 py-1.5 text-xs md:text-sm text-white focus:outline-none focus:ring-2 focus:ring-cyan-500"
                >
                  <option value="es">🇪🇸 {t('español')}</option>
                  <option value="en">🇺🇸 {t('ingles')}</option>
                </select>
                
                <div className={`px-2 py-1 rounded-full text-xs font-bold ${
                  plan === 'starter' ? 'bg-gray-600/30 text-gray-400' :
                  plan === 'pro' ? 'bg-cyan-500/20 text-cyan-400' :
                  plan === 'business' ? 'bg-purple-500/20 text-purple-400' :
                  'bg-yellow-500/20 text-yellow-400'
                }`}>
                  {plan === 'starter' ? t('planStarter') :
                   plan === 'pro' ? t('planPro') :
                   plan === 'business' ? t('planBusiness') : t('planElite')}
                </div>
                
                <div className="text-xs text-gray-400 hidden md:block">
                  <span className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-emerald-500"></span>
                    {usuarioActual?.email}
                  </span>
                </div>
              </div>
              
              <div className="flex flex-wrap items-center gap-2">
                <button
                  onClick={() => setModalReporteAbierto(true)}
                  disabled={generandoReporte || movimientos.length === 0}
                  className={`flex items-center gap-1 px-2 py-1.5 rounded-lg text-xs font-medium transition-all duration-300 ${
                    generandoReporte || movimientos.length === 0
                      ? 'bg-slate-800 text-slate-500 cursor-not-allowed'
                      : 'bg-emerald-500/10 text-emerald-400 hover:bg-emerald-500/20 border border-emerald-500/30'
                  }`}
                >
                  <span>📊</span>
                  <span className="hidden sm:inline">{generandoReporte ? t('generating') : t('report')}</span>
                </button>

                <button
                  onClick={() => setMostrarConfigModal(true)}
                  className="flex items-center gap-1 px-2 py-1.5 rounded-lg text-xs font-medium bg-purple-500/10 text-purple-400 hover:bg-purple-500/20 border border-purple-500/30 transition-all duration-300"
                >
                  <span>⚙️</span>
                  <span className="hidden sm:inline">{t('audit')}</span>
                </button>

                <button
                  onClick={exportarACSV}
                  disabled={movimientos.length === 0}
                  className={`flex items-center gap-1 px-2 py-1.5 rounded-lg text-xs font-medium transition-all duration-300 ${
                    !puedeAccederAFuncion('puedeExportarExcel')
                      ? 'bg-slate-800 text-slate-500 cursor-not-allowed opacity-50'
                      : movimientos.length === 0
                      ? 'bg-slate-800 text-slate-500 cursor-not-allowed'
                      : 'bg-green-500/10 text-green-400 hover:bg-green-500/20 border border-green-500/30'
                  }`}
                >
                  <span>📎</span>
                  <span className="hidden sm:inline">{t('exportCSV')}</span>
                </button>
                
                <label className={`flex items-center gap-1 px-2 py-1.5 rounded-lg text-xs font-medium transition-all duration-300 cursor-pointer bg-slate-800 hover:bg-slate-700 border border-slate-700 ${subiendoArchivo ? 'opacity-50 cursor-wait' : ''}`}>
                  <span>📎</span>
                  <span className="hidden sm:inline">{subiendoArchivo ? t('attaching') : t('attach')}</span>
                  <input 
                    type="file" 
                    className="hidden" 
                    onChange={handleFileUpload} 
                    accept=".csv" 
                    disabled={subiendoArchivo} 
                  />
                </label>
                
                {puedeAccederAFuncion('puedeVerLogs') && (
                  <button
                    onClick={() => setMostrarLogsEliminaciones(!mostrarLogsEliminaciones)}
                    className="flex items-center gap-1 px-2 py-1.5 rounded-lg text-xs font-medium bg-purple-500/10 text-purple-400 hover:bg-purple-500/20 border border-purple-500/30 transition-all"
                  >
                    <span>📋</span>
                    <span className="hidden sm:inline">{t('viewLogs')}</span>
                  </button>
                )}
                
                <button
                  onClick={async () => {
                    try {
                      const auth = getAuth();
                      await signOut(auth);
                      window.location.href = '/';
                    } catch (error) {
                      console.error('Error al cerrar sesión:', error);
                    }
                  }}
                  className="flex items-center gap-1 px-2 py-1.5 rounded-lg text-xs font-medium bg-red-500/10 text-red-400 hover:bg-red-500/20 border border-red-500/30 transition-all"
                >
                  <span>🚪</span>
                  <span className="hidden sm:inline">{t('logout')}</span>
                </button>
                
                <div className="text-xs text-gray-400">
                  <span className="flex items-center">
                    <span className={`w-1.5 h-1.5 rounded-full mr-1 ${isLoading ? 'bg-yellow-500 animate-pulse' : 'bg-emerald-500'}`}></span>
                    <span className="hidden sm:inline">{isLoading ? t('connecting') : t('online')}</span>
                  </span>
                </div>
              </div>
            </div>
            
            {/* Mi Plan (solo visible en móvil cuando el header está expandido) */}
            <div className="mt-3 md:hidden">
              <div className="bg-gradient-to-r from-blue-900/30 to-purple-900/30 rounded-2xl p-2 border border-blue-500/30">
                <div className="flex flex-row justify-between items-center gap-2">
                  <div className="flex items-center gap-2">
                    <span className="text-sm">🎯</span>
                    <h3 className="text-xs font-bold text-white">{t('miPlanActual')}</h3>
                  </div>
                  <button
                    onClick={() => setModalUpgradeOpen(true)}
                    className="px-2 py-1 bg-cyan-500/20 hover:bg-cyan-500/30 border border-cyan-500/50 rounded-lg text-cyan-400 font-medium transition-all text-[10px] whitespace-nowrap"
                  >
                    {t('cambiarPlan')}
                  </button>
                </div>
                <div className="grid grid-cols-4 gap-1.5 mt-2">
                  <div className="bg-slate-800/50 rounded-lg p-1.5 text-center">
                    <p className="text-gray-400 text-[8px] uppercase">{t('plan')}</p>
                    <p className="text-[10px] font-bold text-white truncate">
                      {plan === 'starter' ? t('planStarter') :
                       plan === 'pro' ? t('planPro') :
                       plan === 'business' ? t('planBusiness') : t('planElite')}
                    </p>
                  </div>
                  <div className="bg-slate-800/50 rounded-lg p-1.5 text-center">
                    <p className="text-gray-400 text-[8px] uppercase">{t('reports') || 'Reportes'}</p>
                    <p className="text-[10px] font-bold text-white">
                      {plan === 'elite' ? '∞' : plan === 'business' ? `${20 - (usuarioActual?.reportesGenerados?.[new Date().toLocaleString('en-CA').slice(0, 7)] || 0)}/${20}` : plan === 'pro' ? `${5 - (usuarioActual?.reportesGenerados?.[new Date().toLocaleString('en-CA').slice(0, 7)] || 0)}/${5}` : `${1 - (usuarioActual?.reportesGenerados?.[new Date().toLocaleString('en-CA').slice(0, 7)] || 0)}/${1}`}
                    </p>
                  </div>
                  <div className="bg-slate-800/50 rounded-lg p-1.5 text-center">
                    <p className="text-gray-400 text-[8px] uppercase">{t('days')}</p>
                    <p className="text-[10px] font-bold text-white">{diasRestantes > 0 ? diasRestantes : '0'}</p>
                  </div>
                  <div className="bg-slate-800/50 rounded-lg p-1.5 text-center">
                    <p className="text-gray-400 text-[8px] uppercase">{t('capitalInjected')}</p>
                    <p className={`text-[10px] font-bold truncate ${(usuarioActual?.deudaConDueño || 0) > 0 ? 'text-yellow-400' : 'text-green-400'}`}>
                      {formatearValor(usuarioActual?.deudaConDueño || 0)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <Toaster position="top-center" reverseOrder={false} />

      {/* ============================================================
          VERSIÓN PARA PC (CON CUADROS CORREGIDOS)
          ============================================================ */}
      <div className="desktop-only hidden md:block">
        <div id="dashboard-insights">
          {dashboardInsightsComponent}
        </div>

        <main className="max-w-7xl mx-auto px-4 py-6">
          {tieneAcceso ? (
            <>
              {error && (
                <div className={`mb-6 p-4 rounded-xl text-sm ${
                  error.includes('NO RENTABLE') || error.includes('excede') || error.includes('Sargento Financiero') || error.includes('OPERACIÓN BLOQUEADA')
                    ? 'bg-red-900/50 border border-red-500/50 text-red-300'
                    : 'bg-red-900/20 border border-red-500/30 text-red-400'
                }`}>
                  {error}
                </div>
              )}
              
              {validationMessage && (
                <div className="mb-6 p-4 bg-yellow-900/20 border border-yellow-500/30 rounded-xl text-yellow-400 text-sm">
                  {validationMessage}
                </div>
              )}

              {puedeAccederAFuncion('puedeVerAnomalias') && valoresAtipicos.length > 0 && (
                <div className="mb-6 p-4 bg-orange-900/30 border border-orange-500/50 rounded-xl">
                  <h4 className="text-orange-400 font-bold mb-2">{t('outlierAlert')}</h4>
                  {valoresAtipicos.slice(0, 3).map((atipico, idx) => (
                    <div key={idx} className="text-sm text-orange-200 mb-1">
                      {atipico.concepto}: {formatearValor(atipico.valor)} - {t('outlierAlertDesc')}
                    </div>
                  ))}
                </div>
              )}

              {inconsistenciaSaldo?.inconsistente && (
                <div className="mb-6 p-4 bg-red-900/30 border border-red-500/50 rounded-xl">
                  <h4 className="text-red-400 font-bold mb-2">{t('inconsistencyAlert')}</h4>
                  <p className="text-sm text-red-200">{t('inconsistencyAlertDesc')}</p>
                  <p className="text-xs text-red-300 mt-2">Diferencia: {formatearValor(inconsistenciaSaldo.diferencia)}</p>
                </div>
              )}

              {mostrarLogsEliminaciones && (
                <div className="fixed inset-0 bg-black/80 z-[100] flex items-center justify-center p-4" onClick={() => setMostrarLogsEliminaciones(false)}>
                  <div className="bg-[#1e293b] rounded-2xl p-6 max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                    <div className="flex justify-between items-center mb-4">
                      <h3 className="text-xl font-bold text-white">{t('viewLogs')}</h3>
                      <button onClick={() => setMostrarLogsEliminaciones(false)} className="text-gray-400 hover:text-white text-2xl">&times;</button>
                    </div>
                    {logsEliminaciones.length === 0 ? (
                      <p className="text-gray-400 text-center py-8">No hay registros de eliminaciones</p>
                    ) : (
                      <div className="space-y-3">
                        {logsEliminaciones.map((log) => (
                          <div key={log.id} className="bg-slate-800/50 p-3 rounded-lg">
                            <p className="text-red-400 text-sm font-bold">Eliminado: {log.concepto}</p>
                            <p className="text-gray-400 text-xs">Valor: {formatearValor(log.valor)}</p>
                            <p className="text-gray-500 text-xs">Fecha original: {log.fechaRegistroOriginal ? new Date(log.fechaRegistroOriginal).toLocaleDateString('es-CO') : 'N/A'}</p>
                            <p className="text-gray-500 text-xs">Eliminado por: {log.userEmail}</p>
                            <p className="text-gray-500 text-xs">Fecha eliminación: {log.fechaEliminacion?.toDate ? new Date(log.fechaEliminacion.toDate()).toLocaleString('es-CO') : 'N/A'}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {kpiCardsComponent}

              <TrustMeter 
                registrosCompletos={movimientos.filter(m => m.valor).length}
                registrosTotales={Math.max(10, movimientos.length)}
                pais={moneda.codigo === 'COP' ? 'CO' : 'US'}
                idioma={idioma}
              />

              <div className="mb-6"></div>

              <div className="bg-gradient-to-r from-blue-900/30 to-purple-900/30 rounded-2xl p-4 mb-6 border border-blue-500/30">
                <div className="flex flex-row justify-between items-center gap-4">
                  <div>
                    <h3 className="text-lg font-bold text-white flex items-center gap-2">
                      <span>🎯</span> {t('miPlanActual')}
                    </h3>
                    <p className="text-gray-400 text-xs">{t('gestionaSuscripcion')}</p>
                  </div>
                  <button
                    onClick={() => setModalUpgradeOpen(true)}
                    className="px-4 py-1.5 bg-cyan-500/20 hover:bg-cyan-500/30 border border-cyan-500/50 rounded-lg text-cyan-400 font-medium transition-all text-xs"
                  >
                    {t('cambiarPlan')}
                  </button>
                </div>

                <div className="grid grid-cols-3 sm:grid-cols-5 gap-2 mt-3">
                  <div className="bg-slate-800/50 rounded-lg p-2 text-center">
                    <p className="text-gray-400 text-[10px] uppercase">{t('plan')}</p>
                    <p className="text-sm font-bold text-white">
                      {plan === 'starter' ? t('planStarter') :
                       plan === 'pro' ? t('planPro') :
                       plan === 'business' ? t('planBusiness') : t('planElite')}
                    </p>
                  </div>
                  
                  <div className="bg-slate-800/50 rounded-lg p-2 text-center">
                    <p className="text-gray-400 text-[10px] uppercase">{t('reports') || 'Reportes'}</p>
                    <p className="text-sm font-bold text-white">
                      {plan === 'elite' 
                        ? '∞' 
                        : plan === 'business'
                          ? `${20 - (usuarioActual?.reportesGenerados?.[new Date().toLocaleString('en-CA').slice(0, 7)] || 0)}/${20}`
                          : plan === 'pro'
                            ? `${5 - (usuarioActual?.reportesGenerados?.[new Date().toLocaleString('en-CA').slice(0, 7)] || 0)}/${5}`
                            : `${1 - (usuarioActual?.reportesGenerados?.[new Date().toLocaleString('en-CA').slice(0, 7)] || 0)}/${1}`}
                    </p>
                  </div>
                  
                  <div className="bg-slate-800/50 rounded-lg p-2 text-center">
                    <p className="text-gray-400 text-[10px] uppercase">{t('days')}</p>
                    <p className="text-sm font-bold text-white">
                      {diasRestantes > 0 ? diasRestantes : '0'}
                    </p>
                  </div>

                  <div className="bg-slate-800/50 rounded-lg p-2 text-center col-span-2">
                    <p className="text-gray-400 text-[10px] uppercase">{t('capitalInjected')}</p>
                    <p className={`text-sm font-bold ${(usuarioActual?.deudaConDueño || 0) > 0 ? 'text-yellow-400' : 'text-green-400'}`}>
                      {formatearValor(usuarioActual?.deudaConDueño || 0)}
                    </p>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
                {configuracionAuditoriaComponent}
                <div className="bg-[#1e293b] border border-blue-900/30 rounded-2xl p-6 h-full">
                  <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
                    <span>📊</span> {t('incomeVsExpenses')}
                  </h3>
                  {datosGrafico && datosGrafico.length > 0 && (
                    <ResponsiveContainer width="100%" height={200}>
                      <BarChart data={datosGrafico} layout="vertical" margin={{ left: 40 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
                        <XAxis type="number" tickFormatter={(v) => `$${(v/1000).toFixed(0)}k`} stroke="#94a3b8" />
                        <YAxis dataKey="nombre" type="category" stroke="#94a3b8" width={80} />
                        <Tooltip formatter={(v) => `$${v.toLocaleString()}`} contentStyle={{ backgroundColor: '#0f172a', borderColor: '#38bdf8', borderRadius: '8px' }} />
                        <Bar dataKey="valor" radius={[0, 4, 4, 0]} fill="#8884d8">
                          {datosGrafico.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                          ))}
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  )}
                  {(!datosGrafico || datosGrafico.length === 0) && (
                    <div className="h-[200px] flex items-center justify-center text-gray-500">
                      No hay datos suficientes para mostrar el gráfico
                    </div>
                  )}
                  <div className="mt-3 flex justify-center gap-4 text-xs flex-wrap">
                    <div className="flex items-center gap-1"><div className="w-3 h-3 rounded-full bg-emerald-500"></div><span>{t('sales')}</span></div>
                    <div className="flex items-center gap-1"><div className="w-3 h-3 rounded-full bg-red-500"></div><span>{t('expenses')}</span></div>
                    <div className="flex items-center gap-1"><div className="w-3 h-3 rounded-full bg-amber-500"></div><span>{t('purchases')}</span></div>
                    <div className="flex items-center gap-1"><div className="w-3 h-3 rounded-full bg-purple-500"></div><span>{t('capital')}</span></div>
                    <div className="flex items-center gap-1"><div className="w-3 h-3 rounded-full bg-cyan-500"></div><span>{t('profit')}</span></div>
                  </div>
                </div>
              </div>

              {inventarioComponent}
              {produccionComponent}
              {executiveReportComponent}
              {registroManualComponent}
              
              {(plan === 'business' || plan === 'elite') && (
                <MassiveUpload
                  usuarioActual={usuarioActual}
                  moneda={moneda}
                  onComplete={(results) => {
                    const exitosos = results.filter(r => r.success).length;
                    setValidationMessage(`✅ ${exitosos} de ${results.length} documentos procesados exitosamente`);
                    setTimeout(() => setValidationMessage(null), 5000);
                  }}
                  onError={(error) => {
                    setError(error.message);
                    setTimeout(() => setError(null), 5000);
                  }}
                />
              )}

              <div className="max-w-3xl mx-auto mb-8">
                <p className="text-center text-gray-500 text-sm">
                  {idioma === 'es' 
                    ? '💡 Puedes registrar tus movimientos manualmente arriba. Los usuarios Business y Elite también pueden subir múltiples facturas a la vez.'
                    : '💡 You can register your transactions manually above. Business and Elite users can also upload multiple invoices at once.'}
                </p>
              </div>

              {registrosListComponent}
            </>
          ) : (
            <div className="bg-[#1e293b] rounded-2xl p-12 mb-8 border border-yellow-500/30 text-center">
              <div className="text-6xl mb-4">🔒</div>
              <h2 className="text-2xl font-bold text-yellow-400 mb-4">
                {idioma === 'en' ? 'Access Restricted' : 'Acceso Restringido'}
              </h2>
              <p className="text-gray-400 max-w-md mx-auto mb-6">
                {plan === 'starter' && diasRestantes === 0
                  ? (idioma === 'en' 
                      ? 'Your 15-day free trial has ended. Subscribe to continue using STRATIUM GLOBAL AI.'
                      : 'Tu prueba gratuita de 15 días ha terminado. Suscríbete para seguir usando STRATIUM GLOBAL AI.')
                  : (idioma === 'en'
                      ? 'To access all STRATIUM GLOBAL AI features, please activate your subscription.'
                      : 'Para acceder a todas las funciones de STRATIUM GLOBAL AI, por favor activa tu suscripción.')}
              </p>
              <button
                onClick={() => {
                  setFuncionBloqueada('Dashboard completo');
                  setModalUpgradeOpen(true);
                }}
                className="px-8 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-bold rounded-lg transition-all"
              >
                {idioma === 'en' ? 'Subscribe Now' : 'Suscribirme ahora'}
              </button>
            </div>
          )}
        </main>
      </div>

      {/* ============================================================
          VERSIÓN PARA MÓVIL (con pestañas - SOLO visible en celular - INTACTA)
          ============================================================ */}
      <div className="mobile-only block md:hidden">
        <main className="px-2 py-3 pb-20">
          {tieneAcceso ? (
            <>
              {error && (
                <div className={`mb-4 p-3 rounded-xl text-xs ${
                  error.includes('NO RENTABLE') || error.includes('excede') || error.includes('Sargento Financiero') || error.includes('OPERACIÓN BLOQUEADA')
                    ? 'bg-red-900/50 border border-red-500/50 text-red-300'
                    : 'bg-red-900/20 border border-red-500/30 text-red-400'
                }`}>
                  {error}
                </div>
              )}
              
              {validationMessage && (
                <div className="mb-4 p-3 bg-yellow-900/20 border border-yellow-500/30 rounded-xl text-yellow-400 text-xs">
                  {validationMessage}
                </div>
              )}

              <MobileTabs
                kpis={kpiCardsMobileComponent}
                trustMeter={
                  <TrustMeter 
                    registrosCompletos={movimientos.filter(m => m.valor).length}
                    registrosTotales={Math.max(10, movimientos.length)}
                    pais={moneda.codigo === 'COP' ? 'CO' : 'US'}
                    idioma={idioma}
                  />
                }
                dashboardInsights={dashboardInsightsComponent}
                inventario={inventarioComponent}
                registros={registrosListComponent}
                registroManual={registroManualExpandido}
                produccion={produccionExpandido}
                configuracion={configuracionAuditoriaComponent}
                idioma={idioma}
                dictamen={dictamenAuditoriaComponent}
              />
            </>
          ) : (
            <div className="bg-[#1e293b] rounded-2xl p-8 mb-8 border border-yellow-500/30 text-center">
              <div className="text-6xl mb-4">🔒</div>
              <h2 className="text-xl font-bold text-yellow-400 mb-4">
                {idioma === 'en' ? 'Access Restricted' : 'Acceso Restringido'}
              </h2>
              <p className="text-gray-400 text-sm max-w-md mx-auto mb-6">
                {plan === 'starter' && diasRestantes === 0
                  ? (idioma === 'en' 
                      ? 'Your 15-day free trial has ended. Subscribe to continue using STRATIUM GLOBAL AI.'
                      : 'Tu prueba gratuita de 15 días ha terminado. Suscríbete para seguir usando STRATIUM GLOBAL AI.')
                  : (idioma === 'en'
                      ? 'To access all STRATIUM GLOBAL AI features, please activate your subscription.'
                      : 'Para acceder a todas las funciones de STRATIUM GLOBAL AI, por favor activa tu suscripción.')}
              </p>
              <button
                onClick={() => {
                  setFuncionBloqueada('Dashboard completo');
                  setModalUpgradeOpen(true);
                }}
                className="px-6 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-bold rounded-lg transition-all text-sm"
              >
                {idioma === 'en' ? 'Subscribe Now' : 'Suscribirme ahora'}
              </button>
            </div>
          )}
        </main>
      </div>

      <footer className="py-6 px-4 border-t border-blue-900/20 mt-12">
        <div className="max-w-7xl mx-auto text-center text-gray-500 text-sm">
          <p>STRATIUM GLOBAL AI © {new Date().getFullYear()} • {t('subtitle')}</p>
        </div>
      </footer>

      {/* Modales */}
      <ModalUpgrade
        isOpen={modalUpgradeOpen}
        onClose={() => setModalUpgradeOpen(false)}
        funcionNombre={funcionBloqueada}
        onSeleccionarPlan={(plan) => {
          console.log('🔍 DEBUG - Plan seleccionado:', plan);
          console.log('🔍 DEBUG - usuarioActual?.uid:', usuarioActual?.uid);
          setModalUpgradeOpen(false);
          localStorage.setItem('pendingPlan', plan);
          localStorage.setItem('pendingUserId', usuarioActual?.uid);
          setPlanSeleccionadoPago(plan);
          console.log('🔍 DEBUG - setPlanSeleccionadoPago llamado con:', plan);
          setMostrarCheckout(true);
          console.log('🔍 DEBUG - mostrarCheckout seteado a true');
        }}
        moneda={moneda}
        t={t}
        onComprarCreditosSoporte={(paqueteId, paquete) => {
          console.log('🔍 DEBUG - Paquete de soporte seleccionado:', paqueteId, paquete);
          localStorage.setItem('pendingPaqueteSoporte', paqueteId);
          localStorage.setItem('pendingPaqueteSoporteData', JSON.stringify(paquete));
          setPlanSeleccionadoPago(`creditos_soporte_${paqueteId}`);
          console.log('🔍 DEBUG - setPlanSeleccionadoPago llamado con:', `creditos_soporte_${paqueteId}`);
          setMostrarCheckout(true);
          console.log('🔍 DEBUG - mostrarCheckout seteado a true (paquete soporte)');
        }}
      />
      
      <ModalFechaVencimiento
        isOpen={mostrarModalVencimiento}
        onClose={() => setMostrarModalVencimiento(false)}
        onGuardar={handleGuardarConVencimiento}
        onSaltar={handleSaltarVencimiento}
        producto={productoPendiente}
      />

      {mostrarCheckout && (
        <CheckoutMercadoPago
          plan={planSeleccionadoPago}
          userEmail={usuarioActual?.email}
          userId={usuarioActual?.uid}
          moneda={moneda?.codigo || 'COP'}
          onSuccess={() => {
            console.log("✅ Pago exitoso");
            setMostrarCheckout(false);
            setValidationMessage('✅ Pago exitoso. Tu plan ha sido actualizado.');
            setTimeout(() => setValidationMessage(null), 5000);
            setTimeout(() => window.location.reload(), 2000);
          }}
          onError={(error) => {
            console.log("❌ Error en pago:", error);
            setMostrarCheckout(false);
            setError('Error en el pago: ' + error);
            setTimeout(() => setError(null), 5000);
          }}
          onClose={() => {
            console.log("❌ Modal cerrado");
            setMostrarCheckout(false);
          }}
        />
      )}

      {modalReporteAbierto && (
        <SelectorReporte
          isOpen={modalReporteAbierto}
          onClose={() => setModalReporteAbierto(false)}
          onSelect={handleGenerarReporte}
          usuarioActual={usuarioActual}
          idioma={idioma}
        />
      )}

      {/* SupportBot - MÓVIL: subido a bottom-24 para no tapar menú | PC: bottom-6 */}
      <div className="fixed bottom-24 right-4 z-[9999] block md:hidden">
        <SupportBot 
          usuarioActual={usuarioActual}
          idioma={idioma}
          plan={plan}
          moneda={moneda}
          resumenFinanciero={resumenFinanciero}
          diagnosticoBienvenida={diagnosticoBienvenida}
          variant="mobile"
        />
      </div>

      {/* SupportBot para PC - se mantiene abajo en su esquina original */}
      <div className="fixed bottom-6 right-4 z-[9999] hidden md:block">
        <SupportBot 
          usuarioActual={usuarioActual}
          idioma={idioma}
          plan={plan}
          moneda={moneda}
          resumenFinanciero={resumenFinanciero}
          diagnosticoBienvenida={diagnosticoBienvenida}
          variant="compact"
        />
      </div>

    </div>
  );
};

export default Dashboard;

